// This file is for Junior Mint, addapted from Sejour room file, roomTypes2.js
/* This files contains for ALL room types the rooms photos (more than 1) and overall description */
/* The details include: standard room type has two subtypes, with 2 and 3 beds respectively. Same is true for family type */
export const roomType2 = [
    {
        id: 0,
        category: 'rooms',
        type: 'apt',
        name: 'Apartment',
        nameJ: 'アパート',
        caption: 'A two-bedroom apartment that offers everything you would expect from a modern home—and more. One bedroom features traditional Japanese styling, while the spacious living room is perfect for accommodating additional guests.',
        captionJ: '2ベッドルームのアパートメントで、現代的な住まいに求められるすべてを備え、それ以上の魅力も提供します。1つの寝室は和室で、広々としたリビングルームは追加のゲストを快適に迎えることができます。',
        captionCh1: '这是一间两卧室公寓，提供现代家庭所需的一切设施，甚至更多。其中一间卧室采用传统的日式风格设计，而宽敞的客厅非常适合接待额外的客人。',
        captionCh2: '這是一間兩臥室的公寓，提供現代家庭所需的一切設施，甚至更多。其中一間臥室採用傳統日式風格設計，而寬敞的客廳非常適合接待額外的客人。',
        numGuests: 2,
        images: [ 
            {
                id: 0,
                image: '/assets/images/rooms/jm/apt/jm-rooms-apt1.jpg'
            },
            {
                id: 1,
                image: '/assets/images/rooms/jm/apt/jm-rooms-apt1-1.jpg'
            },
            {
                id: 2,
                image: '/assets/images/rooms/jm/apt/jm-rooms-apt2.jpg'
            },
            {
                id: 3,
                image: '/assets/images/rooms/jm/apt/jm-rooms-apt3.jpg'
            },
            {
                id: 4,
                image: '/assets/images/rooms/jm/apt/jm-rooms-apt4.jpg'
            },
            {
                id: 5,
                image: '/assets/images/rooms/jm/apt/jm-rooms-apt5.jpg'
            },
            {
                id: 6,
                image: '/assets/images/rooms/jm/apt/jm-rooms-apt6.jpg'
            },
            {
                id: 7,
                image: '/assets/images/rooms/jm/apt/jm-rooms-apt7.jpg'
            },
            {
                id: 8,
                image: '/assets/images/rooms/jm/apt/jm-rooms-apt8.jpg'
            },
            {
                id: 9,
                image: '/assets/images/rooms/jm/apt/jm-rooms-apt9.jpg'
            },
            {
                id: 10,
                image: '/assets/images/rooms/jm/apt/jm-rooms-apt10.jpg'
            },
            {
                id: 11,
                image: '/assets/images/rooms/jm/apt/jm-rooms-apt11.jpg'
            },
            {
                id: 12,
                image: '/assets/images/rooms/jm/apt/jm-rooms-apt12.jpg'
            },
            {
                id: 13,
                image: '/assets/images/rooms/jm/apt/jm-rooms-apt13.jpg'
            },
            {
                id: 14,
                image: '/assets/images/rooms/jm/apt/jm-rooms-apt14.jpg'
            },
            {
                id: 15,
                image: '/assets/images/rooms/jm/apt/jm-rooms-apt15.jpg'
            },
            {
                id: 16,
                image: '/assets/images/rooms/jm/apt/jm-rooms-apt16.jpg'
            },
            {
                id: 17,
                image: '/assets/images/rooms/jm/apt/jm-rooms-apt17.jpg'
            },
            {
                id: 18,
                image: '/assets/images/rooms/jm/apt/jm-rooms-apt18.jpg'
            },
            {
                id: 19,
                image: '/assets/images/rooms/jm/apt/jm-rooms-apt19.jpg'
            }
        ]
    },
    {
    id: 1,
    category: 'rooms',
    type: 'twin',
    name: 'Twin Rooms',
    nameJ: 'ツイン',
    caption: 'A Twin Room has two single beds and an en suite bathroom/toilet with a bathtub and shower.',
    captionJ: 'ツインルームにはシングルベッドが2つあり、専用のバスルーム/トイレがついており、バスタブとシャワーがあります。',
    captionCh1: '双人房拥有两张单人床，以及带浴缸和淋浴的套间浴室/卫生间。',
    captionCh2: '雙人房擁有兩張單人床，以及帶浴缸和淋浴的套間浴室/衛生間。',
    numGuests: 2,
    images: [ 
        {
            id: 0,
            image: '/assets/images/rooms/jm/twin/jm-rooms-twin1.jpg'
        },
        {
            id: 1,
            image: '/assets/images/rooms/jm/twin/jm-rooms-twin2.jpg'
        },
        {
            id: 2,
            image: '/assets/images/rooms/jm/twin/jm-rooms-twin3.jpg'
        },
        {
            id: 3,
            image: '/assets/images/rooms/jm/twin/jm-rooms-twin4.jpg'
        }
    ]
    },
    {
        id: 2,
        category: 'rooms',
        type: 'double',
        name: 'Double Rooms',
        nameJ: 'ダブル',
        caption: 'This Double Room has a double bed and an en suite bathroom/toilet with a bathtub and shower. ',
        captionJ: 'ダブルルームにはダグルベッドがひとつあり、専用のバスルーム/トイレがついており、バスタブとシャワーがあります。',
        captionCh1: '双人间有一张双人床以及带浴缸和淋浴的套间浴室/卫生间。',
        captionCh2: '雙人間有一張雙人床以及帶浴缸和淋浴的套間浴室/廁所。',
        numGuests: 3,
        images: [ 
            {
                id: 0,
                image: '/assets/images/rooms/jm/double/jm-rooms-double1.jpg'
            },
            {
                id: 1,
                image: '/assets/images/rooms/jm/double/jm-rooms-double2.jpg'
            },
            {
                id: 2,
                image: '/assets/images/rooms/jm/double/jm-rooms-double3.jpg'
            },
            {
                id: 3,
                image: '/assets/images/rooms/jm/double/jm-rooms-double4.jpg'
            },
            {
                id: 3,
                image: '/assets/images/rooms/jm/double/jm-rooms-double5.jpg'
            }
        ]
    },
    {
        id: 3,
        category: 'rooms',
        type: 'tripleD',
        name: 'Triple Rooms with A Double Bed and Sofa Bed',
        nameJ: 'ダブルベッドのトリプル',
        caption: 'This Triple Room has a double bed and a sofa bed and an en suite bathroom/toilet with a bathtub and shower. ',
        captionJ: 'トリプルルームにはダグルベッドとソファベッドがひとつつづあり、専用のバスルーム/トイレがついており、バスタブとシャワーがあります。',
        captionCh1: '三人间有一张双人床和一张沙发床，以及带浴缸和淋浴的套间浴室/卫生间。',
        captionCh2: '三人間有一張雙人床和一張沙發床，以及帶浴缸和淋浴的套間浴室/廁所。',
        numGuests: 3,
        images: [ 
            {
                id: 0,
                image: '/assets/images/rooms/jm/double/jm-rooms-double1.jpg'
            },
            {
                id: 1,
                image: '/assets/images/rooms/jm/double/jm-rooms-double2.jpg'
            }
        ]
        },
    {
        id: 4,
        category: 'rooms',
        type: 'tripleT',
        name: 'Triple Room with Single Beds',
        nameJ: 'シングルベッドのトリプルルーム',
        caption: 'This Triple Room has a 2 single beds and a sofa bed and an en suite bathroom/toilet with a bathtub and shower. ',
        captionJ: 'トリプルルームにはシングルベッドが二つ、とソファベッドがひとつあり、専用のバスルーム/トイレがついており、バスタブとシャワーがあります。',
        captionCh1: '三人间有二张单人床和一张沙发床，以及带浴缸和淋浴的套间浴室/卫生间。',
        captionCh2: '三人間有二張單人床和一張沙發床，以及帶浴缸和淋浴的套間浴室/廁所。',
        numGuests: 5,
        images: [ 
            {
                id: 0,
                image: '/assets/images/rooms/jm/twin/jm-rooms-twin1.jpg'
            },
            {
                id: 1,
                image: '/assets/images/rooms/jm/twin/jm-rooms-twin2.jpg'
            }
        ]
    }
]